angular.module(NgAppName).component('crImagesUploader', {
	templateUrl: 'crImagesUploader.html',
	bindings: {
		uploadRpc: '<',
		imagesList: '<',
		isMobile: '<',
		sizeLimit: '@',
		moveImages: '@',
		filesExtension: '@',
		amountLimit: '<',
		compressionQuality: '<'
	},
	controller: ['$element', '$timeout', '$http', function($element, $timeout, $http) {
		var ctrl = this;
		this.imagesList = this.imagesList || [];
		this.errorMessage = '';
		this.totalSize = 0;
		this.uploadedImagesAmount = this.imagesList.length;
		this.extensionList = this.filesExtension.split(',');
		this.sizeList = [];

		var handleDragOver = function(evt) {
			evt.stopPropagation();
			evt.preventDefault();
			evt.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
		};

		this.sendFile = function(file, settings) {
			ctrl.isLoading = true;
			$http({
				method: 'post',
				url: ctrl.uploadRpc,
				headers: {
					'Cache-Control': 'no-cache',
					'X-Requested-With': 'XMLHttpRequest',
					'X-File-Id': settings.id,
					'X-File-Name': settings.name,
					'X-File-Size': settings.size,
					'X-File-Resume': settings.resume
				},
				data: file
			}).success(function(data) {
				if (data) {
					if (data.status) {
						var url = data.url + '?id=' + Date.now();
						ctrl.imagesList.push(url);
						ctrl.uploadedImagesAmount ++;
						ctrl.sizeList[url] = settings.size;
						if (ctrl.moveImages === "true") {
							ctrl.setMoveImages();
						}
					} else {
						ctrl.errorMessage = data.message;
					}
					ctrl.filesLength --;
					if (ctrl.filesLength <= 0) {
						ctrl.isLoading = false;
					}
				}
			});
		};

		this.handleFileSelect = function(evt) {
			evt.stopPropagation();
			evt.preventDefault();
			ctrl.errorMessage = '';
			var files = evt.dataTransfer ? evt.dataTransfer.files : evt.target.files;
			var filesLength = files.length;
			if (filesLength + ctrl.uploadedImagesAmount > ctrl.amountLimit) {
				ctrl.isAmountLimitReached = true;
				ctrl.setErrorMessage();
			} else {
				ctrl.isAmountLimitReached = false;
				ctrl.filesLength = filesLength;
				angular.forEach(files, function(file) {
					// Only process image files.
					var fileName = file.name;
					var fileExt = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
					if (ctrl.extensionList.indexOf(fileExt) === -1) {
						ctrl.isFileAnImage = false;
						ctrl.setErrorMessage();
						ctrl.filesLength --;
					} else {
						ctrl.isFileAnImage = true;
						if (ctrl.totalSize > ctrl.sizeLimit || ((file.size / 1024 / 1024 + ctrl.totalSize) > ctrl.sizeLimit)) {
							ctrl.isSizeLimitReached = true;
							ctrl.setErrorMessage();
							ctrl.filesLength --;
						} else {
							ctrl.isSizeLimitReached = false;
							var reader = new FileReader();
							reader.onload = function(event) {
								var selectedImage = new Image();
								selectedImage.src = event.target.result;
								selectedImage.onload = function(){
									var settings = {
										id: Date.now(),
										name: file.name,
										resume: false
									};
									ctrl.compressImage(selectedImage, settings);
								}
							};
							// Read in the image file as a data URL.
							reader.readAsDataURL(file);
						}
					}
				});
			}
			ctrl.input[0].value = '';
		};

		this.compressImage = function(selectedImage, settings) {
			var cvs = document.createElement('canvas');
			cvs.width = selectedImage.naturalWidth;
			cvs.height = selectedImage.naturalHeight;
			var ctx = cvs.getContext("2d").drawImage(selectedImage, 0, 0);
			var newImageData = cvs.toBlob(
				function (blob) {
					ctrl.totalSize += blob.size / 1024 / 1024; // transform to Mb.
					settings.size = blob.size;
					ctrl.sendFile(blob, settings)
				},
				'image/jpeg',
				ctrl.compressionQuality / 100);
		};

		this.input = angular.element($element[0].querySelector('input[type=file]'));
		if (this.input) {
			this.input.bind('change', this.handleFileSelect);
		}

		this.setErrorMessage = function() {
			if (this.isAmountLimitReached) {
				$timeout(function() {
					ctrl.errorMessage = "<sup>*</sup> Sorry, you’ve reached the limit of " +
						ctrl.amountLimit + " image" + (ctrl.amountLimit > 1 ? "s  allowed for upload" : " allowed for upload");
				});
			} else if (!ctrl.isFileAnImage) {
				$timeout(function() {
					ctrl.errorMessage = "<sup>*</sup> We accept only " + ctrl.extensionList.join(' ') + " files";
				});
			} else if (ctrl.isSizeLimitReached) {
				$timeout(function() {
					ctrl.errorMessage = "<sup>*</sup> Limit of images size is " + ctrl.sizeLimit + "Mb";
				});
			} else {
				$timeout(function() {
					ctrl.errorMessage = null;
				});
			}
		};

		this.deleteImage= function(index) {
			var fileSize = ctrl.sizeList[ctrl.imagesList[index]];
			if (fileSize) {
				ctrl.totalSize -= fileSize / 1024 / 1024; // transform to Mb.
				ctrl.sizeList[ctrl.imagesList[index]] = null;
			}
			ctrl.imagesList.splice(index, 1);
			ctrl.uploadedImagesAmount --;
			ctrl.isAmountLimitReached = false;
			ctrl.isFileAnImage = true;
			ctrl.isSizeLimitReached = false;
			ctrl.setErrorMessage();
		};

		// Setup the dnd listeners.
		if (!this.isMobile) {
			// make the whole element droppable
			var dropZone = angular.element($element[0].querySelector('div.drop-zone'));
			if (dropZone) {
				dropZone.bind('dragover', function(ev) {
					handleDragOver(ev);
					$timeout(function() {
						ctrl.dropZoneIsActive = true;
					});
				});
				dropZone.bind('dragleave', function(ev) {
					$timeout(function() {
						ctrl.dropZoneIsActive = false;
					});
				});
				dropZone.bind('drop', function(ev) {
					ctrl.handleFileSelect(ev);
					ctrl.dropZoneIsActive = false;
				});
			}
		}

		var move = function(arr, old_index, new_index) {
			while (old_index < 0) {
				old_index += arr.length;
			}
			while (new_index < 0) {
				new_index += arr.length;
			}
			if (new_index >= arr.length) {
				var k = new_index - arr.length;
				while ((k--) + 1) {
					arr.push(undefined);
				}
			}
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			return arr;
		};

		var dragEndImage = function(ev) {
			ev.preventDefault();
			var fromIndex = ev.dataTransfer.getData("index");
			var toIndex = ev.target.getAttribute('data-index');
			$timeout(function() {
				ctrl.imagesList = move(ctrl.imagesList, fromIndex, toIndex);
			});
		};

		var dragStartImage = function(ev) {
			ev.dataTransfer.setData("index", ev.target.getAttribute('data-index'));
		};

		var bindMoveEvents = function() {
			var lis = $element[0].getElementsByClassName('image');
			angular.forEach(lis, function(li) {
				var el = angular.element(li);
				el.unbind('dragover', handleDragOver).bind('dragover', handleDragOver);
				el.unbind('drop', dragEndImage).bind('drop', dragEndImage);

				var img = angular.element(li.getElementsByClassName('thumb'));
				img.unbind('dragstart', dragStartImage).bind('dragstart', dragStartImage);
			});
		};

		this.setMoveImages = function() {
			if (!ctrl.isMobile) {
				$timeout(function() {
					bindMoveEvents();
				});
			}
		};

		if (this.moveImages === "true" && this.imagesList.length > 0) {
			this.setMoveImages();
		}
	}]
});
